// E³-Survey Web結果画面のアイコン（プロトタイプ v3.0 の <symbol> 定義をそのまま移植）。
// 結果UIパーツ集の CSS が「線のアイコン」（stroke: currentColor / fill: none）前提のため、
// 塗りの antd アイコンではなくこちらを使う。
import React from 'react';

const PATHS = {
  'users': (
    <><circle cx="9" cy="8" r="3.2" /><path d="M3 20c0-3.3 2.7-5 6-5s6 1.7 6 5" /><path d="M16 5.2A3.2 3.2 0 0 1 16 11M21 20c0-3-1.6-4.6-4-4.9" /></>
  ),
  'calendar': (
    <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></>
  ),
  'clock': (
    <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>
  ),
  'layers': (
    <><path d="M12 3l9 5-9 5-9-5z" /><path d="M3 13l9 5 9-5" /></>
  ),
  'chevron-down': (
    <><polyline points="6 9 12 15 18 9" /></>
  ),
  'chevron-left': (
    <><polyline points="15 6 9 12 15 18" /></>
  ),
  'download': (
    <><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" /><path d="M12 4v12M7 11l5 5 5-5" /></>
  ),
  'printer': (
    <><path d="M6 9V3h12v6" /><rect x="3" y="9" width="18" height="8" rx="2" /><path d="M6 14h12v7H6z" /></>
  ),
  'chart': (
    <><path d="M4 19V5M4 19h16M8 16v-5M13 16V8M18 16v-8" /></>
  ),
  'target': (
    <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.5" /></>
  ),
  'message': (
    <><path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" /></>
  ),
  'up': (
    <><path d="M12 19V5M5 12l7-7 7 7" /></>
  ),
  'down': (
    <><path d="M12 5v14M5 12l7 7 7-7" /></>
  ),
  'info': (
    <><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></>
  ),
  'lock': (
    <><rect x="4" y="11" width="16" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" /></>
  ),
  'hourglass': (
    <><path d="M7 3h10M7 21h10M8 3c0 5 8 5 8 9s-8 4-8 9M16 3c0 5-8 5-8 9s8 4 8 9" /></>
  ),
  'check': (
    <><polyline points="20 6 9 17 4 12" /></>
  ),
  'sparkle': (
    <><path d="M12 3l1.8 4.7L18 9.5l-4.2 1.8L12 16l-1.8-4.7L6 9.5l4.2-1.8z" /></>
  ),
  'home': (
    <><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /></>
  ),
};

const E3Icon = ({ name, className }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {PATHS[name] || null}
  </svg>
);

export default E3Icon;
